import styled from "styled-components";
import { themes } from "../../Utils/themes";
import { device } from "../../Utils/device";

export const Content = styled.div`
  transition: all 0.3s;
  padding: 12px;
  @media ${device.desktop} {
    padding: 30px;
  }
`;

export const ContentItemWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 5px;
  list-style: none;
  border-bottom: 2px solid #dfdad8;
  margin-bottom: 10px;
  line-height: 36px;
  color: #fff;
  @media ${device.desktop} {
    padding: 15px 5px;
  }
`;

export const ModelName = styled.h3`
  margin: 5px;
  padding: 5px;
  line-height: 1.5;
  font-size: ${themes.textSize.s3};
  color: ${themes.colors.text};
  @media ${device.tablet} {
    font-size: ${themes.textSize.m1};
  }
  @media ${device.desktop} {
    margin: 10px;
    padding: 20px;
    font-size: ${themes.textSize.m2};
  }
`;

export const SpecWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: end;
  gap: 8px;
  @media ${device.desktop} {
    gap: 28px;
  }
`;

export const SpecLabel = styled.div`
  padding: 0 5px;
  font-size: ${themes.textSize.s3};
  color: ${themes.colors.text};
  border-radius: 10px;
  width: fit-content;
  cursor: pointer;
  width: 55px;
  text-align: center;
  color: ${themes.colors.text};
  background-color: ${themes.colors.caution};
  border-bottom: 5px solid ${themes.colors.disabled};
  font-weight: bold;
  @media ${device.tablet} {
    font-size: ${themes.textSize.m1};
    width: 60px;
  }
  @media ${device.desktop} {
    padding: 5px 8px;
    width: 65px;
  }
  &:hover {
    margin-top: 3px;
    background: ${themes.colors.caution};
    border-bottom: 2px solid ${themes.colors.border};
  }
`;
